import { render, staticRenderFns } from "./PageProfile.vue?vue&type=template&id=55090061&scoped=true&"
import script from "./PageProfile.vue?vue&type=script&lang=js&"
export * from "./PageProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55090061",
  null
  
)

export default component.exports